export function getInitials(fullName: string): string {
    if (!fullName) return "";
    
    return fullName
      .trim()
      .split(/\s+/) // découpe par espace(s) multiples
      .map(word => word.charAt(0).toUpperCase())
      .join('');
  }

  export function capitalizeWords(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase());
}

export function toCamelCase(input: string): string {
  return input
    .toLowerCase()
    .split('_')
    .map((word, index) =>
      index === 0 ? word : word[0].toUpperCase() + word.slice(1)
    )
    .join('');
}